/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreAssessment from './pre-assessment';
import PreAssessmentDetail from './pre-assessment-detail';
import PreAssessmentUpdate from './pre-assessment-update';
import PreAssessmentDeleteDialog from './pre-assessment-delete-dialog';

const PreAssessmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreAssessment />} />
    <Route path="new" element={<PreAssessmentUpdate />} />
    <Route path=":id">
      <Route index element={<PreAssessmentDetail />} />
      <Route path="edit" element={<PreAssessmentUpdate />} />
      <Route path="delete" element={<PreAssessmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreAssessmentRoutes;
